import { JOB_CATEGORIES } from '../constants/jobCategories';
import React from 'react';

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export function CategoryTabs({
  activeCategory,
  onCategoryChange
}: CategoryTabsProps) {
  return (
    <div className="mt-12">
      <div className="mx-auto max-w-fit rounded bg-[#E2E2E2] p-2">
        <div className="flex gap-2">
          {JOB_CATEGORIES.map(category => (
            <button
              key={category.id}
              type="button"
              className={`min-h-[40px] min-w-[80px] rounded-[4px] text-xs font-semibold text-[#242424] transition-colors hover:bg-[#D70C18] hover:text-white focus:outline-none md:min-w-[160px] md:text-sm ${
                activeCategory === category.id
                  ? 'bg-[#D70C18] text-white'
                  : 'bg-white text-[#242424]'
              }`}
              style={{ border: 'none', boxShadow: 'none' }}
              onClick={() => onCategoryChange(category.id)}
            >
              <span className="hidden md:inline">{category.label}</span>
              <span className="whitespace-pre-line md:hidden">
                {category.mobileLabel}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
